<div class="seg-agents-widget">
  @if (profiles?.length) {
    @for (seg of profiles!; track trackByIndex($index)) {
      <div [style]="styles.section">
        <div [style]="styles.subHeading">{{ seg.segName }}</div>
        @if (seg.agents.length) {
          <table [style]="styles.table">
            <thead>
              <tr>
                <th [style]="styles.headerCell">{{ labels.agent }}</th>
                <th [style]="styles.headerCell">{{ labels.exposureBand }}</th>
                <th [style]="styles.headerCell">{{ labels.likelihood }}</th>
                <th [style]="styles.headerCell">{{ labels.method }}</th>
                <th [style]="styles.headerCell">{{ labels.baseOel }}</th>
                <th [style]="styles.headerCell">{{ labels.correctedOel }}</th>
                <th [style]="styles.headerCell">{{ labels.correction }}</th>
                <th [style]="styles.headerCell">{{ labels.samples }}</th>
                <th [style]="styles.headerCell">{{ labels.qualitative }}</th>
                @if (showResidual) {
                  <th [style]="styles.headerCell">{{ labels.residual }}</th>
                }
                <th [style]="styles.headerCell">{{ labels.controlAdequacy }}</th>
                <th [style]="styles.headerCell">{{ labels.compliance }}</th>
                <th [style]="styles.headerCell">{{ labels.status }}</th>
                <th [style]="styles.headerCell">{{ labels.reassessment }}</th>
                @if (showNotes) {
                  <th [style]="styles.headerCell">{{ labels.notes }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (agent of seg.agents; track trackByIndex($index)) {
                <tr>
                  <td [style]="styles.cell">{{ agent.agentName }}</td>
                  <td [style]="styles.bandCell + agent.cellStyle">{{ agent.exposureBand }}</td>
                  <td [style]="styles.cell">{{ agent.likelihood }}</td>
                  <td [style]="styles.cell">{{ agent.methodOfAssessment }}</td>
                  <td [style]="styles.cell">{{ agent.baseOel }}</td>
                  <td [style]="styles.cell">{{ agent.correctedOel }}</td>
                  <td [style]="styles.cell">{{ agent.correctionMethod }} {{ agent.correctionFactors }}<br><span [style]="styles.tag">{{ agent.correctionParams }}</span></td>
                  <td [style]="styles.cell">{{ agent.samples }}</td>
                  <td [style]="styles.cell">{{ agent.qualitativeScores }}</td>
                  @if (showResidual) {
                    <td [style]="styles.cell">{{ agent.residualScores }}</td>
                  }
                  <td [style]="styles.cell">{{ agent.controlAdequacy }} / {{ agent.postTreatmentControlAdequacy }}</td>
                  <td [style]="styles.cell">{{ agent.complianceState }}</td>
                  <td [style]="styles.cell">{{ agent.assessmentStatus }}</td>
                  <td [style]="styles.cell">{{ agent.reassessmentFrequencyMonths }}</td>
                  @if (showNotes) {
                    <td [style]="styles.cell">{{ agent.note }}<br><span [style]="styles.tag">{{ agent.residualNotes }}</span></td>
                  }
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p [style]="styles.noData">{{ labels.noData }}</p>
        }
      </div>
    }
  } @else {
    <p [style]="styles.noData">{{ labels.noData }}</p>
  }
</div>
